export const NAMESPACE = "MyTasks";

export const WIDTH = 880;

export const TABS = {
  ALL: "all",
  DUE: "due",
  COMPLETE: "complete"
};
